import axios, {
  type AxiosInstance,
  type AxiosProgressEvent,
  type CancelTokenSource,
} from "axios";

export function getCancelTokenSource() {
  return axios.CancelToken.source();
}

export const api = axios.create();

type UploadFileProps = {
  routePrefix: string;
  file: File;
  client?: AxiosInstance;
  uuid: string;
  cancelTokenSource: CancelTokenSource;
  uploadDomain: string;
  withCredentials: boolean;
  headers: Record<string, string>;
  onUploadProgress: (progress: AxiosProgressEvent) => void;
};

export async function uploadFile({
  routePrefix,
  file,
  uuid,
  client = api,
  cancelTokenSource,
  uploadDomain,
  withCredentials,
  headers,
  onUploadProgress,
}: UploadFileProps) {
  const formData = new FormData();

  formData.append("file", file);
  formData.append("name", file.name);
  formData.append("uuid", uuid);

  return client.post(uploadDomain + "/" + routePrefix + "/uploads", formData, {
    withCredentials,
    withXSRFToken: withCredentials,
    cancelToken: cancelTokenSource.token,
    headers: {
      "Content-Type": "multipart/form-data",
      ...headers,
    },
    onUploadProgress,
  });
}
